
export enum UserSnackbarMessage {
  UpdateUserFailed = 'An error occurred during the process.',
  UpdateUserSuccess = 'User was successfully updated.',
  CreateUserSuccess = 'User was successfully created.',
  CreateUserFailed = 'An error occurred during the process.',
}
